// import React, { useState } from 'react';
import React, { useState , useContext } from 'react'
import AuthContext, { AuthProvider } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

const Auth = () => {



  let { loginUser } = useContext(AuthContext)

  let {user} = useContext(AuthContext)
    // console.log(loginUser)
  let navigate = useNavigate()
  const [userId, setUserId] = useState('');
  const [passcode, setPasscode] = useState('');
  const [open, setOpen] = useState(false); // Snackbar
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' | 'error' | 'info' | 'warning'
  const [loading, setLoading] = useState(false); 

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };


  const handleLogin = async () => {
    setLoading(true);
  
    if (userId && passcode) {
    const statusCode = await loginUser(userId, passcode)
    if (statusCode !== 200) {
        setLoading(false);
    }
    }
    //   try {
    //     // const api_link = 'https://api.mba-gris.stgafrica.org/user-auth/'
    //     const api_link = 'http://localhost:8000/user-auth/';

  
    //     const response = await fetch(api_link, {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //       body: JSON.stringify({ username: userId, passcode: passcode }),
    //     });
  
    //     const data = await response.json();
  
    //     if (response.ok) {
    //       // Successful login
    //       setSnackbarMessage('Login successful! Redirecting...');
    //       setSnackbarSeverity('success');
    //       setOpen(true);
    //       setTimeout(() => {
    //         navigate('/selection')
    //         // window.location.href = '/selection';
    //       }, 2000);
    //     } else if (response.status === 401) {
    //       setSnackbarMessage('Invalid credentials. Please try again.');
    //       setSnackbarSeverity('error');
    //       setOpen(true);
    //       // alert('Invalid credentials. Please check your username and passcode.');
    //     } else if (response.status === 400) {
    //       // alert(data.error || 'Bad request. Make sure all fields are filled.');
    //       setSnackbarMessage(data.error || 'Bad request. Missing fields.');
    //       setSnackbarSeverity('warning');
    //       setOpen(true);
    //     } else {
    //       // alert('Unexpected error. Please try again.');
    //       setSnackbarMessage('Network error. Contact Admin.');
    //       setSnackbarSeverity('error');
    //       setOpen(true);
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     alert('An error occurred. Contact Admin for assistance.');
    //   } finally {
    //     setLoading(false);
    //   }
    // } else {
    //   setSnackbarMessage('Both UserID and Passcode must be provided.');
    //   setSnackbarSeverity('warning');
    //   setOpen(true);
    //   setLoading(false);
    // }
  };
  
  return (
    <div style={myStyle.boxStyle}>
      <h1>Welcome Back</h1>
      <p>Hello there, sign in to continue</p>
      <img src={require('../assets/images/Illustration.png')} height={100} width={125} alt="" />

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={snackbarSeverity} variant="filled" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box component="form" sx={{ '& > :not(style)': { width: '100%', marginTop:'20px' } }} >
        <TextField
          label="User ID"
          variant="outlined"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          required
        />
        <TextField
          style={{ marginTop: '20px' }}
          label="Passcode"
          type="password"
          variant="outlined"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          required
        />
        <div style={{ marginTop: '40px' }}></div>
        <Button
          onClick={handleLogin}
          variant="contained"
          size="large"
          style={{ padding: '10px' }}
          endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          disabled={loading}
        >
          {loading ? 'Signing In...' : 'Sign In'}
        </Button>
      </Box>
    </div>
  );
};

const myStyle = {
  boxStyle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '98vh',
  },
};

export default Auth;
